<template>
<main class="SeccionBuscador-MAIN">

    <section role="search">
        <div class="INNER-MARGIN SeccionBuscador-search">
            <input type="text" v-model="searchTerm" @keyup.enter="searchCupones()" :disabled="searchActive"/>
            <button @click="searchCupones()" :disabled="searchActive"><img src="../assets/search.png" /></button>
        </div>
    </section>

    <section class="SeccionBuscador-results">
        
        <p v-if="searchActive">Buscando "{{ searchTerm }}"...</p>
        <div v-if="searchResults.length > 0" class="SeccionBuscador-grid-results">
            <a v-for="(item, index) in searchResults" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id" target="_blank"><img :src="item.url_banner"  @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}"/></a>
        </div>
        <h2 v-if="searchResults.length <= 0 && !searchActive"><i>No se encontraron resultados.</i></h2>

    </section>

</main>
</template>

<script>
export default {
    name: 'SeccionBuscador',
    data(){
        return{
            searchTerm: '',
            searchResults: [],
            searchActive: false,
        }
    },

    methods: {
        getFrontURL(){
			return window.location.origin;
		},

        async searchCupones(){
            const term = this.searchTerm.trim();
            if(!term || term == "") return;
            this.searchActive = true;

            const response = await fetch("https://promo-colaboradores.ideeo.mx/api/buscar?busqueda="+term, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const result = await response.json();
            this.searchResults = result.data;
            this.searchActive = false;
        },
    },

    mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        const query = urlParams.get('q');
        if(query && query.trim() != ""){
            this.searchTerm = query;
            this.searchCupones();
        }
    }
}
</script>

<style scoped>
.SeccionBuscador-MAIN{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vw;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Benton Sans BBVA medium';
}

.SeccionBuscador-MAIN > section{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.SeccionBuscador-MAIN > section:first-child{
    height: 80px;
}

.SeccionBuscador-search{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2ch 0;
}

.SeccionBuscador-search input{
    height: 4ch;
    width: calc(100% - 6ch);
}

.SeccionBuscador-search button{
    max-width: 5ch;
    max-height: 5ch;
    padding: 0;
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1ch;
    cursor: pointer;
}

.SeccionBuscador-search button img{
    max-width: 100%;
    max-height: 100%;
}

.SeccionBuscador-results{
    overflow-y: auto;
    padding-bottom: 5ch;
    height: calc(100vh - 80px);
}

.SeccionBuscador-grid-results{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
    width: 90%;
    margin: 4ch 0;
}

.SeccionBuscador-grid-results a{
    width: 100%;
}

.SeccionBuscador-grid-results a > img{
    max-width: 100%;
}
</style>